var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-muted mb-4 mt-3 text-center"},[_vm._v(" "+_vm._s(_vm.headerText)+" ")]),(!_vm.phone)?_c('phone-form',{on:{"otp-sent":_vm.onOTPSent}}):_c('otp-form',{attrs:{"phone":_vm.phone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }